"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var FilterProducts = /** @class */ (function (_super) {
    __extends(FilterProducts, _super);
    function FilterProducts() {
        var _this = _super.call(this, constants_1.DATA_FILTER_PRODUCTS) || this;
        if (!_this.getElement())
            return _this;
        _this.filterProducts = _this.getElement();
        _this.filterProductsSelectBranches = _this.filterProducts.querySelector("[".concat(constants_1.DATA_FILTER_PRODUCTS_SELECT_BRANCHES, "]"));
        _this.filterProductsSelectMaterials = _this.filterProducts.querySelector("[".concat(constants_1.DATA_FILTER_PRODUCTS_SELECT_MATERIALS, "]"));
        _this.filterProductsOptionsBranches = _this.filterProducts.querySelector("[".concat(constants_1.DATA_FILTER_PRODUCTS_OPTIONS_BRANCHES, "]"));
        _this.filterProductsOptionsMaterials = _this.filterProducts.querySelector("[".concat(constants_1.DATA_FILTER_PRODUCTS_OPTIONS_MATERIALS, "]"));
        _this.filterProductsSubmitButton = _this.filterProducts.querySelector("[".concat(constants_1.DATA_FILTER_PRODUCTS_SUBMIT_BUTTON, "]"));
        _this.filters = [
            {
                select: _this.filterProductsSelectBranches,
                options: _this.filterProductsOptionsBranches
            },
            {
                select: _this.filterProductsSelectMaterials,
                options: _this.filterProductsOptionsMaterials
            }
        ];
        _this.closeAllFilters();
        _this.initEventListeners();
        return _this;
    }
    FilterProducts.prototype.initEventListeners = function () {
        var _this = this;
        var _a;
        document.addEventListener('click', function (event) {
            _this.checkForOutsideClick(event);
        });
        (_a = this.filters) === null || _a === void 0 ? void 0 : _a.forEach(function (filter) {
            var _a;
            (_a = filter === null || filter === void 0 ? void 0 : filter.select) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
                var _a;
                filter.select.classList.toggle(constantsClasses_1.CLASS_OPEN);
                (_a = filter === null || filter === void 0 ? void 0 : filter.options) === null || _a === void 0 ? void 0 : _a.classList.toggle(constantsClasses_1.CLASS_HIDE);
            });
        });
        this.filterProductsSubmitButton.addEventListener('click', function (e) {
            return _this.filterRequest(e);
        });
        this.countCheckboxChecked();
    };
    /**
     * Filter request.
     *
     * @param e
     * @private
     */
    FilterProducts.prototype.filterRequest = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var submitButton, form, formData, url, response, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        e.preventDefault();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        submitButton = e.target;
                        form = submitButton.form;
                        formData = new FormData(form);
                        url = form.getAttribute('action');
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                body: formData
                            })];
                    case 2:
                        response = _b.sent();
                        _a = document.documentElement;
                        return [4 /*yield*/, response.text()];
                    case 3:
                        _a.innerHTML = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        throw new Error('An error occurred during the filter request: ' + error_1.message);
                    case 5:
                        document.dispatchEvent(new Event('DOMContentLoaded'));
                        return [2 /*return*/];
                }
            });
        });
    };
    FilterProducts.prototype.countCheckboxChecked = function () {
        var _a, _b;
        var branchChecked = 0;
        var materialsChecked = 0;
        (_a = this.filters) === null || _a === void 0 ? void 0 : _a.forEach(function (filter) {
            var options = filter.options.getElementsByTagName('input');
            for (var i = 0; i < options.length; i++) {
                if (options[i].checked && options[i].classList.contains('input--checkbox--branch')) {
                    branchChecked++;
                    filter.select.nextElementSibling.nextElementSibling.firstElementChild.innerHTML = branchChecked.toString();
                    filter.select.nextElementSibling.nextElementSibling.firstElementChild.classList.add('show');
                }
                if (options[i].checked && options[i].classList.contains('input--checkbox--material')) {
                    materialsChecked++;
                    filter.select.nextElementSibling.nextElementSibling.firstElementChild.innerHTML = materialsChecked.toString();
                    filter.select.nextElementSibling.nextElementSibling.firstElementChild.classList.add('show');
                }
            }
        });
        (_b = this.filters) === null || _b === void 0 ? void 0 : _b.forEach(function (filter) {
            var _a;
            var options = filter.options.getElementsByTagName('input');
            var _loop_1 = function (i) {
                (_a = options[i]) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
                    if (options[i].checked && options[i].classList.contains('input--checkbox--branch')) {
                        branchChecked++;
                        filter.select.nextElementSibling.nextElementSibling.firstElementChild.innerHTML = branchChecked.toString();
                        filter.select.nextElementSibling.nextElementSibling.firstElementChild.classList.add('show');
                    }
                    else if (!options[i].checked && branchChecked > 0 && options[i].classList.contains('input--checkbox--branch')) {
                        branchChecked--;
                        filter.select.nextElementSibling.nextElementSibling.firstElementChild.innerHTML = branchChecked.toString();
                        if (branchChecked == 0) {
                            filter.select.nextElementSibling.nextElementSibling.firstElementChild.classList.remove('show');
                        }
                    }
                    if (options[i].checked && options[i].classList.contains('input--checkbox--material')) {
                        materialsChecked++;
                        filter.select.nextElementSibling.nextElementSibling.firstElementChild.innerHTML = materialsChecked.toString();
                        filter.select.nextElementSibling.nextElementSibling.firstElementChild.classList.add('show');
                    }
                    else if (!options[i].checked && materialsChecked > 0 && options[i].classList.contains('input--checkbox--material')) {
                        materialsChecked--;
                        filter.select.nextElementSibling.nextElementSibling.firstElementChild.innerHTML = materialsChecked.toString();
                        if (materialsChecked == 0) {
                            filter.select.nextElementSibling.nextElementSibling.firstElementChild.classList.remove('show');
                        }
                    }
                });
            };
            for (var i = 0; i < options.length; i++) {
                _loop_1(i);
            }
        });
    };
    FilterProducts.prototype.closeAllFilters = function () {
        var _a;
        (_a = this.filters) === null || _a === void 0 ? void 0 : _a.forEach(function (filter) {
            var _a, _b;
            (_a = filter.options) === null || _a === void 0 ? void 0 : _a.classList.add(constantsClasses_1.CLASS_HIDE);
            (_b = filter.select) === null || _b === void 0 ? void 0 : _b.classList.remove(constantsClasses_1.CLASS_OPEN);
        });
    };
    FilterProducts.prototype.closeMaterials = function () {
        this.filterProductsOptionsMaterials.classList.add(constantsClasses_1.CLASS_HIDE);
        this.filterProductsSelectMaterials.classList.remove(constantsClasses_1.CLASS_OPEN);
    };
    FilterProducts.prototype.closeBranches = function () {
        this.filterProductsOptionsBranches.classList.add(constantsClasses_1.CLASS_HIDE);
        this.filterProductsSelectBranches.classList.remove(constantsClasses_1.CLASS_OPEN);
    };
    FilterProducts.prototype.checkForOutsideClick = function (event) {
        var elements = event.composedPath();
        // -2 because we want to skip document and window (unless you are not using document as parent)
        for (var i = 0; i < elements.length - 2; i++) {
            var el = elements[i];
            // Don't trigger if modal is targeted
            if (el.classList.contains('product-filter__select--branches') || el.classList.contains('product-filter__select-option--branch')) {
                this.closeMaterials();
                return;
            }
            if (el.classList.contains('product-filter__select--materials') || el.classList.contains('product-filter__select-option--material')) {
                this.closeBranches();
                return;
            }
            if (el.classList.contains('product-filter__select-wrapper')) {
                return;
            }
        }
        this.closeAllFilters();
    };
    return FilterProducts;
}(AbstractComponent_1.default));
exports.default = FilterProducts;
